<template>
    <div>
        <label for="pricegroup">Prijsgroep (*)</label>
        <select id="pricegroup" name="pricegroup" class="form-control" v-model="selectedGroup">
            <option value="99">Selecteer prijsgroep</option>
            <option v-for="price in pricegroups" :value="price">Prijsgroep <span v-text="price"></span></option>
        </select>
    </div>
</template>

<script>
import {EventBus} from "../../events";

export default {
    name: "Pricegroup",
    props: {
        currentGroup: {
            required: false,
            type: Number,
        }
    },

    data() {
        return {
            pricegroups: [0, 1, 2, 3, 4, 5],
            selectedGroup: ''
        };
    },

    mounted() {
        this.selectedGroup = this.currentGroup;
    },

    watch: {
        selectedGroup: function(newGroup) {
            EventBus.$emit('changePricegroup', newGroup);
        }
    }
}
</script>

<style scoped>

</style>
